export enum DropdownEntitiesEnum {
	Diets = 'diets',
	AchievementTypes = 'achievement_types',
	MessageAttachmentTypes = 'message_attachment_types',
	NotificationTypes = 'notification_types',
	PrivacyTypes = 'privacy_types',
	ScheduleRepeatTypes = 'schedule_repeat_types',
	Genders = 'genders',
	AccountPrivacyOptions = 'accounts_privacy_options',
	LocationPrivacyOptions = 'location_privacy_options',
	Interests = 'interests',
	InterestSources = 'interest_sources',
	Cities = 'cities',
}
